'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { DEMO_SHIFT_ANCHOR } from './-api';
import { EmployeeWorkScheduleDetailPage } from './-components/EmployeeWorkScheduleDetailPage';
import { type WorkScheduleDisplay, type WorkScheduleView, workScheduleSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_individual/individual/portal/lookup/work-schedule/')({
  validateSearch: workScheduleSearchSchema,
  component: WorkSchedulePage
});
function WorkSchedulePage() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const view: WorkScheduleView = search.view ?? 'monthly';
  const display: WorkScheduleDisplay = search.display ?? 'calendar';
  const anchorIso = search.anchor ?? DEMO_SHIFT_ANCHOR;
  return <EmployeeWorkScheduleDetailPage view={view} display={display} anchorIso={anchorIso} onChangeView={v => void navigate({
    search: prev => ({
      ...prev,
      view: v
    })
  })} onChangeDisplay={d => void navigate({
    search: prev => ({
      ...prev,
      display: d
    })
  })} onChangeAnchor={iso => void navigate({
    search: prev => ({
      ...prev,
      anchor: iso
    })
  })} />;
}